import React from 'react';

export function Upload () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.5 5.25v6.25h11V5.25M6 7.5v-7m0 0L3.375 3.125M6 .5l2.625 2.625"
      />
    </svg>
  );
}
